/**
 * Nuture Cart Sync
 *
 * Duas utilidades globais do carrinho, carregadas junto do cart custom.
 *
 * 1. Contador da navbar (cart-icon)
 *    RafobaseCart.refreshThemeCart e o cart custom disparam
 *    `shopify:cart:lines-update` com um promise SEM cart.totalQuantity nem
 *    detail.itemCount. O <cart-icon> do Horizon, nesse caso, calcula 0 e some
 *    com a bolha (bug: o contador da navbar "não atualiza"). Aqui, a cada
 *    lines-update, relemos /cart.js e forçamos o número certo na bolha.
 *    Não editamos cart-icon.js — é core do Horizon.
 *
 * 2. Botão "Limpar carrinho" (`[data-cart-clear]`)
 *    Esvazia via /cart/clear.js e dispara o evento padrão pro
 *    cart-items-component re-renderizar o drawer in-place (sem reload).
 */
(function () {
  if (window.__nutureCartSync) return;
  window.__nutureCartSync = true;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // 1. Mantém a bolha do <cart-icon> em sincronia com a contagem real.
  var syncing = false;
  function syncBubble() {
    if (syncing) return;
    syncing = true;
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var icon = document.querySelector('cart-icon');
        if (icon && typeof icon.renderCartBubble === 'function') {
          icon.renderCartBubble(cart.item_count);
        }
      })
      .catch(function () {
        /* cosmético — se falhar, a próxima navegação corrige a bolha */
      })
      .finally(function () {
        syncing = false;
      });
  }
  document.addEventListener('shopify:cart:lines-update', syncBubble);

  // 2. Botão "Limpar carrinho".
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-cart-clear]');
    if (!btn) return;

    e.preventDefault();
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';

    fetch(rootUrl() + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/clear.js HTTP ' + r.status);
        return r.json();
      })
      .then(function () {
        // Evento padrão → o cart-items-component re-renderiza o drawer pro
        // estado vazio; o syncBubble acima zera a navbar. Resolvemos o promise
        // com os dados reais (0) pra também alimentar o <cart-icon> direto.
        var evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        evt.action = 'remove';
        evt.promise = Promise.resolve({
          cart: { totalQuantity: 0 },
          detail: { itemCount: 0, source: 'nuture-cart-clear' },
        });
        document.dispatchEvent(evt);
      })
      .catch(function (err) {
        console.error('[nuture-cart-sync] Falha ao limpar carrinho:', err);
      })
      .finally(function () {
        delete btn.dataset.busy;
      });
  });
})();
